import { NIRO } from "./types";

export const niroAction = () => {
  return {
    type: NIRO,
  };
};
